module.exports = __webpack_public_path__ + "img/identity.e3b40b79.svg";